import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z\" fill=\"#9A2391\"></path><path d=\"M5 7H19\" stroke=\"#F7F7F7\"></path><path d=\"M5 10.3333H10.6\" stroke=\"#F7F7F7\"></path><path d=\"M11.5332 10.3333L18.9999 10.3333\" stroke=\"#F7F7F7\"></path><path d=\"M5 13.6667H15.2667\" stroke=\"#F7F7F7\"></path><path d=\"M16.2002 13.6667L19.0002 13.6667\" stroke=\"#F7F7F7\"></path><path d=\"M5 17H19\" stroke=\"#F7F7F7\"></path>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_9))
}